import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Input, Space } from 'antd';
import { txt } from 'libs/i18n';
import isUrl from 'is-valid-http-url';
import { useState } from 'react';
import { MediaUrl } from 'screens/DashboardScreen/media-upload/media-origin';
import { MediaOriginsList } from 'screens/DashboardScreen/media-upload/media-origins-list';
import styles from './style.module.less';
import MediaOriginView from '../MediaOriginsUpload/MediaOriginView';
const SHORTENED_URLS = ['fb.watch'];
const LinkUpload = ({ mediaOriginsList = new MediaOriginsList([]), isSingleFileUpload, onChange = () => { }, }) => {
    const [urlAdress, setUrlAdress] = useState({
        path: '',
        validityError: 'invalid',
    });
    const handleUrlInputChange = async ({ target: { value } }) => {
        const inputValue = value.trim();
        if (SHORTENED_URLS.some((url) => inputValue.includes(url))) {
            setUrlAdress({ path: inputValue, validityError: 'shortened' });
            return Promise.reject(txt('invalidShortUrl'));
        }
        setUrlAdress({ path: inputValue, validityError: 'none' });
        if (await isUrl(inputValue)) {
            return Promise.resolve();
        }
        setUrlAdress({ path: inputValue, validityError: 'invalid' });
        return Promise.reject(txt('invalidUrl'));
    };
    const handleAddUrlOrigin = () => {
        const urlFile = new MediaUrl(urlAdress.path);
        onChange(mediaOriginsList.addUrl(urlFile));
        setUrlAdress({ path: '', validityError: 'invalid' });
    };
    const handleRemoveUrl = (mediaUrl) => {
        onChange(mediaOriginsList.removeUrl(mediaUrl));
    };
    const validUrl = urlAdress.path !== '' && urlAdress.validityError !== 'none';
    const isUploadLimited = isSingleFileUpload && mediaOriginsList.files.length > 0;
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: styles.urlInputLabel, children: txt('insertUrl') }), _jsxs(Space.Compact, { className: styles.urlInput, children: [_jsx(Input, { id: "input-link-url", type: "url", disabled: isUploadLimited, placeholder: "https://", value: urlAdress.path, onChange: handleUrlInputChange }), _jsx(Button, { id: "action-add-link-url", disabled: urlAdress.validityError !== 'none', className: styles.urlInputButton, type: "default", onClick: handleAddUrlOrigin, children: txt('add') })] }), validUrl
                ? _jsx("p", { className: styles.urlInputError, children: urlAdress.validityError === 'shortened' ? txt('invalidShortUrl') : txt('invalidUrl') })
                : null, mediaOriginsList.urls.map((mediaUrl) => (_jsx(MediaOriginView, { mediaOrigin: mediaUrl, onRemoveOrigin: handleRemoveUrl }, mediaUrl.getId())))] }));
};
export default LinkUpload;
